import { render } from "./Widget9.vue?vue&type=template&id=10f0d3b5"
import script from "./Widget9.vue?vue&type=script&lang=ts"
export * from "./Widget9.vue?vue&type=script&lang=ts"
script.render = render

export default script